import {
  Box,
  Text,
  TextInput,
  ActionIcon,
  Avatar,
  UnstyledButton,
  // TODO: re-enable Badge when the alerts icon ships.
  // Badge,
  Kbd,
  Group,
} from '@mantine/core'
import {
  IconSearch,
  // TODO: re-enable when the alerts icon ships.
  // IconBell,
  IconUser,
  IconLogout,
  IconShieldLock,
  // TODO: re-enable when the settings page ships.
  // IconSettings,
} from '@tabler/icons-react'
import { spotlight } from '@mantine/spotlight'
import { useDisclosure } from '@mantine/hooks'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getProfilePhotoUrl } from '../../api/graph'
import { isAdminUser } from '../../api/allowlist'
import { AdminUsers } from './AdminUsers'

export function Header() {
  const [username, setUsername] = useState<string | null>(null)
  const [displayName, setDisplayName] = useState<string | null>(null)
  const [photoUrl, setPhotoUrl] = useState<string | null>(null)
  const [adminOpened, { open: openAdmin, close: closeAdmin }] =
    useDisclosure(false)
  const navigate = useNavigate()
  const isAdmin = isAdminUser(username)

  useEffect(() => {
    setUsername(localStorage.getItem('prism_username'))
    setDisplayName(localStorage.getItem('prism_display_name'))
  }, [])

  useEffect(() => {
    let objectUrl: string | null = null
    getProfilePhotoUrl()
      .then((url) => {
        objectUrl = url
        setPhotoUrl(url)
      })
      .catch(() => setPhotoUrl(null))

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [])

  const handleLogout = () => {
    localStorage.removeItem('prism_username')
    localStorage.removeItem('prism_auth_method')
    localStorage.removeItem('prism_display_name')
    navigate('/signin')
  }

  return (
    <Box bg="#a8e060" style={{ borderBottom: '1px solid #8fcc40' }}>
      <Box
        h={64}
        px="xl"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box style={{ display: 'flex', alignItems: 'center' }} />

        <Box style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {/* Search */}
          <TextInput
            placeholder="Search pages and data assets…"
            leftSection={<IconSearch size={16} />}
            rightSection={
              <Group gap={4} wrap="nowrap" pr={4}>
                <Kbd size="xs">⌘</Kbd>
                <Kbd size="xs">K</Kbd>
              </Group>
            }
            rightSectionWidth={56}
            w={256}
            size="sm"
            readOnly
            onClick={spotlight.open}
            style={{ cursor: 'pointer' }}
            aria-label="Search Prism pages and data assets"
          />

          {/* TODO: re-enable Notifications (alerts) when it ships.
          <ActionIcon variant="subtle" size="lg" pos="relative" c="#1a3300">
            <IconBell size={18} />
            <Badge
              size="xs"
              color="red"
              pos="absolute"
              top={8}
              right={8}
              style={{ padding: 0, minWidth: 8, width: 8, height: 8 }}
            />
          </ActionIcon>
          */}

          {/* Admin: manage SSO users (only shown to known admins) */}
          {isAdmin && (
            <ActionIcon
              variant="subtle"
              size="lg"
              c="#1a3300"
              onClick={openAdmin}
              title="Manage users"
              aria-label="Manage users"
            >
              <IconShieldLock size={18} />
            </ActionIcon>
          )}

          {/* TODO: re-enable Settings when the settings page ships.
          <ActionIcon
            variant="subtle"
            size="lg"
            c="#1a3300"
            onClick={() => navigate('/settings')}
            title="Settings"
          >
            <IconSettings size={18} />
          </ActionIcon>
          */}

          {/* User menu */}
          <UnstyledButton
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '8px',
              borderRadius: '8px',
              color: '#1a3300',
            }}
          >
            <Avatar
              size="sm"
              radius="xl"
              src={photoUrl}
              alt={displayName ?? username ?? 'User'}
            >
              <IconUser size={16} />
            </Avatar>
            <div style={{ textAlign: 'left' }}>
              {displayName && (
                <Text size="sm" fw={600} c="#1a3300" lh={1.2}>
                  {displayName}
                </Text>
              )}
              <Text size={displayName ? 'xs' : 'sm'} fw={500} c="#1a3300" opacity={displayName ? 0.75 : 1}>
                {username ?? 'Unknown'}
              </Text>
            </div>
          </UnstyledButton>

          {/* Logout */}
          <ActionIcon
            variant="subtle"
            size="lg"
            c="#1a3300"
            onClick={handleLogout}
            title="Log out"
          >
            <IconLogout size={18} />
          </ActionIcon>
        </Box>
      </Box>
      {isAdmin && <AdminUsers opened={adminOpened} onClose={closeAdmin} />}
    </Box>
  )
}
